
import { useState, useEffect } from "react";

const TERMS_FILE_PATH = "/apps/jcom/s4/src/component/jos-terms-and-conditions/js/jos-terms-and-conditions.js";
const TERMS_SCRIPT_SRC = `${process.env.REACT_APP_BASE_PATH}${TERMS_FILE_PATH}`;

export const SCRIPT_STATUS = {
    LOADING: "loading",
    READY: "ready",
    ERROR: "error",
};

export function useTermsAndConditionsScript() {
    const [status, setStatus] = useState(SCRIPT_STATUS.LOADING);

    useEffect(() => {
        const existing = document.querySelector(`script[src="${TERMS_SCRIPT_SRC}"]`);

        if (existing) {
            setStatus(SCRIPT_STATUS.READY);

            return;
        }

        const script = document.createElement("script");
        script.src = TERMS_SCRIPT_SRC;
        script.async = true;

        const onLoad = () => setStatus(SCRIPT_STATUS.READY);
        const onError = () => setStatus(SCRIPT_STATUS.ERROR);

        script.addEventListener("load", onLoad);
        script.addEventListener("error", onError);
        document.body.appendChild(script);

        return () => {
            script.removeEventListener("load", onLoad);
            script.removeEventListener("error", onError);
        };
    }, []);

    return {
        isLoading: status === SCRIPT_STATUS.LOADING,
        isReady: status === SCRIPT_STATUS.READY,
        isError: status === SCRIPT_STATUS.ERROR,
    };
}